// extracted by css-extract-rspack-plugin
export default {"picker":"ymZmVsPsL5gJU1e5","value":"qHFoSBmHMgPXNle_"};